export default __webpack_public_path__ + "img/ciezTXag.1890655b.svg";